<template>
  <a-card :bordered="false" class="card-area">
    <div>
      <!-- 搜索区域 -->
      <a-form layout="horizontal">
        <div style="display: flex;flex-wrap: wrap;gap: 10px;margin-bottom: 10px;align-items: center">
          <a-form-item
            style="width: 350px"
            label="车辆编号"
            :labelCol="{span: 5}"
            :wrapperCol="{span: 17, offset: 2}">
            <a-input placeholder="编号精确搜索" v-model="queryParams.no"/>
          </a-form-item>
          <a-form-item
            label="状态"
            :labelCol="{span: 4}"
            :wrapperCol="{span: 18, offset: 2}">
            <a-select v-model="queryParams.status" style='width: 120px'>
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="1">正常</a-select-option>
              <a-select-option value="0">停用</a-select-option>
            </a-select>
          </a-form-item>


          <a-button type="primary" @click="search">查询</a-button>
          <a-button style="margin-left: 8px" @click="reset">重置</a-button>
        </div>

      </a-form>
    </div>
    <div>
      <!--      <div class="operator">-->
      <!--        <a-button type="primary" v-hasPermission="['car:add']" @click="add">新增</a-button>-->
      <!--      </div>-->
      <!-- 表格区域 -->
      <a-table ref="TableInfo"
               :columns="columns"
               :dataSource="dataSource"
               :pagination="pagination"
               :loading="loading"
               :scroll="{ x: 900 }"
               @change="handleTableChange">
        <template slot="email" slot-scope="text, record">
          <a-popover placement="topLeft">
            <template slot="content">
              <div>{{text}}</div>
            </template>
            <p style="width: 150px;margin-bottom: 0">{{text}}</p>
          </a-popover>
        </template>
        <template slot="operation" slot-scope="text, record">
          <div style="display: flex;flex-wrap: wrap;gap:10px;width: 200px">
            <a-button type="primary" v-hasPermission="['car:add']" @click="edit(record)">编辑</a-button>
            <a-button type="danger" v-hasPermission="['car:add']" @click="del(record)">删除</a-button>
            <a-button type="primary" v-hasNoPermission="['car:add']" @click="edit(record)">详情</a-button>
            <a-button type="primary" @click="location(record)">轨迹查询</a-button>
          </div>
        </template>
        <template slot="status" slot-scope="text, record">
          <a-select v-model="record.status"  style="width: 100px" @change="handleStatusChange(record)">
            <a-select-option :value="0">停用</a-select-option>
            <a-select-option :value="1">正常</a-select-option>
          </a-select>
        </template>
      </a-table>
    </div>

    <a-modal
      :title="modalTitle"
      placement="right"
      width="600px"
      :closable="false"
      :visible="modalVisible"
      @close="onModalClose"
      style="height: calc(100% - 55px);overflow: auto;padding-bottom: 53px;">
      <a-form :form="form" @submit="handleSubmit"  >
        <a-form-item label='区域' v-bind="formItemLayout">
          <AreaCascader @change="onCityChange" ref="addSelect" />
        </a-form-item>
        <a-row :gutter="24">
          <a-col :span="12" >
            <a-form-item label='车辆编号' v-bind="{labelCol: { span:8 },wrapperCol: { span: 16 }}" >
              <a-input :disabled="modalTitle=='编辑'" v-decorator="['no',{rules: [{ required: true, message: '请输入车辆编号' },{ pattern: '^[0-9a-z]{1,20}$', message: '请输入1-20位数字和字母的组合'}]}]"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item label='车辆名称' v-bind="{labelCol: { span:8 },wrapperCol: { span: 16 }}" >
              <a-input :disabled="modalTitle=='编辑'"  v-decorator="['name',{rules: [{ required: true, message: '请输入车辆名称' }]}]"/>
            </a-form-item>
          </a-col>
        </a-row>


        <a-row :gutter="24">
          <a-col :span="12" >
            <a-form-item label='公司名称' v-bind="{labelCol: { span:8 },wrapperCol: { span: 16 }}" >
              <a-input  v-decorator="['company',{rules: []}]"/>
            </a-form-item>
          </a-col>

        </a-row>


        <a-row :gutter="24">
          <a-col :span="12" >
            <a-form-item label='车辆状态'  v-bind="{labelCol: { span:8 },wrapperCol: { span: 16 }}">
              <a-select  v-decorator="['status',{rules: [{ required: true, message: '请选择车辆状态' }]}]"  style="width: 100px" >
                <a-select-option :value="0">停用</a-select-option>
                <a-select-option :value="1">正常</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="12" >
            <a-form-item label='车牌号'   v-bind="{labelCol: { span:8 },wrapperCol: { span: 16 }}">
              <a-input v-decorator="['carNo',{rules: [{  message: '请输入车牌号' }]}]"/>
            </a-form-item>

          </a-col>

        </a-row>





        <a-form-item label='备注' v-bind="formItemLayout">
          <a-input
            type='textarea'
            v-decorator="['remark',{rules: []}]"
          />
        </a-form-item>

      </a-form>
      <template slot="footer">
        <a-button key="back" @click="onModalClose">取消</a-button>
        <a-button key="submit" v-hasPermission="['car:add']" type="primary" :loading="loading" @click="handleSubmit">
          确认
        </a-button>
      </template>
    </a-modal>
  </a-card>
</template>

<script>
import RangeDate from '@/components/datetime/RangeDate'
import area from '../utils/area'
import AreaCascader from '@/components/select/AreaCascader'
import db from 'utils/localstorage'
const formItemLayout = {
  labelCol: {span: 4},
  wrapperCol: {span: 20}
}
export default {
  name: 'Car',
  components: {RangeDate,AreaCascader},
  data () {
    return {
      form: this.$form.createForm(this),
      modalTitle: '',
      companyName:'',
      modalVisible: false,
      modalData: {},
      currentStatus:"",
      options: area,
      formItemLayout,
      queryParams: {status: ''},
      filteredInfo: null,
      sortedInfo: null,
      paginationInfo: null,
      validateStatus: 'success',
      dataSource: [],
      autoData:[],
      selectedRowKeys: [],
      loading: false,
      pagination: {
        pageSizeOptions: ['10', '20', '30', '40', '100'],
        defaultCurrent: 1,
        defaultPageSize: 10,
        showQuickJumper: true,
        showSizeChanger: true,
        showTotal: (total, range) => `显示 ${range[0]} ~ ${range[1]} 条记录，共 ${total} 条记录`
      }
    }
  },
  computed: {
    columns () {
      let {sortedInfo, filteredInfo} = this
      sortedInfo = sortedInfo || {}
      filteredInfo = filteredInfo || {}
      return [{
        title: '车辆名称',
        dataIndex: 'name'
      }, {
        title: '车辆编号',
        dataIndex: 'no'
      }, {
        title: '区属',
        dataIndex: 'areaStr'
      }, {
        title: '车辆状态',
        dataIndex: 'status',
        scopedSlots: {customRender: 'status'}
      }, {
        title: '车牌号',
        dataIndex: 'carNo'
      }, {
        title: '创建时间',
        dataIndex: 'createTime'
      }, {
        title: '最近上线时间',
        dataIndex: 'editTime'
      }, {
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: {customRender: 'operation'}
      }]
    }
  },
  mounted () {
    let user = db.get('USER',{})
    this.companyName = user.companyName
    this.fetch();
  },
  methods: {
    location(record){
      this.$router.push('/page/carLocationDetails?no='+record.no)
    },
    onLoaded(){
      this.fetch();
    },

    onSelect (value) {
      this.form.setFieldsValue({streetId:value})
    },
    handleSearch (value) {
      if (value.length == 0) {
        return
      }
      let areas = this.modalData.areas
      let data = {name: value}
      if (areas) {
        data.area = areas[2]
      }
      this.$get('street/query', data).then((r) => {
        let data = r.data
        this.autoData = data.rows
      }).catch(() => {
      })
    },
    handleStatus(record){
      console.log(`record `,record);
    },
    handleStatusChange (record) {
      this.$post('car/update', {id: record.id, status: record.status}).then((r) => {
        this.$message.success('保存成功')
      })
    },
    downloadTemplate () {
      this.$download('test/template', {}, '导入模板.xlsx')
    },
    onCityChange (value, selectedOptions) {

    },
    handleSubmit () {
      this.form.validateFields((err, values) => {
        if (!err ) {
          let datas = this.form.getFieldsValue()
          this.loading = true
          if(this.modalTitle == "编辑"){
            datas.id = this.modalData.id
            this.$post('car/update', {
              ...datas
            }).then((r) => {
              this.modalVisible = false
              this.$message.success('修改垃圾车成功')
              this.reset()
            }).catch(() => {
              this.loading = false
            })
          }else{
            this.$post('car', {
              ...datas
            }).then((r) => {
              this.modalVisible = false
              this.$message.success('新增垃圾车成功')
              this.reset()
            }).catch(() => {
              this.loading = false
            })
          }
        }
      })
    },
    onModalClose () {
      this.modalVisible = false
    },
    add () {
      this.modalData = {}
      this.modalTitle = '新增'
      this.modalVisible = true
      this.$nextTick(() => {
        this.setFormValues({streetId:this.$refs.select.getValue()})
      })
    },
    edit (record) {
      this.modalTitle = '编辑'
      this.modalVisible = true
      this.modalData = record
      this.$nextTick(() => {
        // this.$refs.select.setValue(record.streetId)
        this.setFormValues(record)
      })
    },
    setFormValues(record){
      let fields = [ 'no','name','status','remark','carNo','company']
      let obj = {}
      for(let filed of fields){
        if(!record.hasOwnProperty(filed)){
          obj[filed] = ''
        }else{
          obj[filed] = record[filed]
        }
      }
      console.info(obj)
      this.$refs.addSelect.setValue(record.streetId)
      this.form.setFieldsValue(obj)
    },
    del (record) {
      let that = this
      this.$confirm({
        title: '确定删除吗?',
        content: '当您点击确定按钮后，这些记录将会被彻底删除',
        centered: true,
        onOk () {
          let userIds = []
          for (let key of that.selectedRowKeys) {
            userIds.push(that.dataSource[key].userId)
          }
          that.$delete('car/' + record.id).then(() => {
            that.$message.success('删除成功')
            that.selectedRowKeys = []
            that.search()
          })
        },
        onCancel () {
          that.selectedRowKeys = []
        }
      })
    },
    batchDelete () {
      if (!this.selectedRowKeys.length) {
        this.$message.warning('请选择需要删除的记录')
        return
      }
      let that = this
      this.$confirm({
        title: '确定删除所选中的记录?',
        content: '当您点击确定按钮后，这些记录将会被彻底删除',
        centered: true,
        onOk () {
          let userIds = []
          for (let key of that.selectedRowKeys) {
            userIds.push(that.dataSource[key].userId)
          }
          // that.$delete('user/' + userIds.join(',')).then(() => {
          //   that.$message.success('删除成功')
          //   that.selectedRowKeys = []
          //   that.search()
          // })

        },
        onCancel () {
          that.selectedRowKeys = []
        }
      })
    },
    resetPassword () {
      if (!this.selectedRowKeys.length) {
        this.$message.warning('请选择需要重置密码的用户')
        return
      }
      let that = this
      this.$confirm({
        title: '确定重置选中用户密码?',
        content: '当您点击确定按钮后，这些用户的密码将会重置为000000',
        centered: true,
        onOk () {
          let usernames = []
          for (let key of that.selectedRowKeys) {
            usernames.push(that.dataSource[key].username)
          }
          that.$put('user/password/reset', {
            usernames: usernames.join(',')
          }).then(() => {
            that.$message.success('重置用户密码成功')
            that.selectedRowKeys = []
          })
        },
        onCancel () {
          that.selectedRowKeys = []
        }
      })
    },
    exportExcel () {
      let {sortedInfo, filteredInfo} = this
      let sortField, sortOrder
      // 获取当前列的排序和列的过滤规则
      if (sortedInfo) {
        sortField = sortedInfo.field
        sortOrder = sortedInfo.order
      }
      this.$export('user/excel', {
        sortField: sortField,
        sortOrder: sortOrder,
        ...this.queryParams,
        ...filteredInfo
      })
    },
    search () {
      let {sortedInfo, filteredInfo} = this
      let sortField, sortOrder
      // 获取当前列的排序和列的过滤规则
      if (sortedInfo) {
        sortField = sortedInfo.field
        sortOrder = sortedInfo.order
      }
      this.fetch({
        sortField: sortField,
        sortOrder: sortOrder,
        ...this.queryParams,
        ...filteredInfo
      })
    },
    reset () {
      // 取消选中
      this.selectedRowKeys = []
      // 重置分页
      this.$refs.TableInfo.pagination.current = this.pagination.defaultCurrent
      if (this.paginationInfo) {
        this.paginationInfo.current = this.pagination.defaultCurrent
        this.paginationInfo.pageSize = this.pagination.defaultPageSize
      }
      // 重置列过滤器规则
      this.filteredInfo = null
      // 重置列排序规则
      this.sortedInfo = null
      // 重置查询参数
      this.queryParams = {}
      // 清空部门树选择
      this.fetch()
    },
    handleTableChange (pagination, filters, sorter) {
      // 将这三个参数赋值给Vue data，用于后续使用
      this.paginationInfo = pagination
      this.filteredInfo = filters
      this.sortedInfo = sorter

      this.fetch({
        sortField: sorter.field,
        sortOrder: sorter.order,
        ...this.queryParams,
        ...filters
      })
    },
    fetch (params = {}) {
      // 显示loading
      this.loading = true
      if (this.paginationInfo) {
        // 如果分页信息不为空，则设置表格当前第几页，每页条数，并设置查询分页参数
        this.$refs.TableInfo.pagination.current = this.paginationInfo.current
        this.$refs.TableInfo.pagination.pageSize = this.paginationInfo.pageSize
        params.pageSize = this.paginationInfo.pageSize
        params.pageNum = this.paginationInfo.current
      } else {
        // 如果分页信息为空，则设置为默认值
        params.pageSize = this.pagination.defaultPageSize
        params.pageNum = this.pagination.defaultCurrent
      }
      params.company = this.companyName
      for(let key in params){
        if(params[key]+"" == 'undefined'){
          params[key] = null
        }
      }
      this.$get('car/list', {
        ...params
      }).then((r) => {
        let data = r.data
        const pagination = {...this.pagination}
        pagination.total = data.total
        this.dataSource = data.rows
        this.pagination = pagination
        // 数据加载完毕，关闭loading
        this.loading = false
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../static/less/Common";

.ant-form-item{
  margin-bottom:0px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/HomePage1.vue